import { useContext, useMemo } from 'react'
import { AppContext, AppContextType } from '../../AppContext'

export default function useAppNotificationActions() {
    const { dispatch: appDispatch } = useContext(AppContext) as AppContextType

    return useMemo(() => {
        function showAppNotification(notification: {
            title: string
            body: string
            muteAudioIfPossible?: boolean
            audioOnly?: boolean
        }) {
            appDispatch({
                type: 'update_app_state',
                value: {
                    appNotification: notification,
                },
            })
        }

        return {
            showAppNotification,
        }
    }, [])
}
